/**
 * @param {'series' | Number | Null} bookId
 * @param {String} attributeType
 * @return {['unknown'] | ['book', number | 'series' | Null, String] | [String]}
 */
export const projectFocusPath = (bookId, attributeType) => {
  if (
    (typeof bookId === 'number' || bookId === 'series') &&
    ['title', 'premise', 'genre', 'theme'].indexOf(attributeType) !== -1
  ) {
    return ['book', bookId, attributeType]
  } else if (['name', 'premise', 'genre', 'theme'].indexOf(attributeType) !== -1) {
    return [attributeType]
  } else {
    return ['unknown']
  }
}
